define('model/ProviderModel',['require','lib/model/BaseModel'],function (require) {
	
	var BaseModel = require('lib/model/BaseModel');
	
	/**
	 * Provider info model
	 * 
	 * @class ProviderModel
	 */
	return BaseModel.extend({
		
		defaults: {
			id: null,
			description: '',
			name: ''
		}
		
	});
	
});
